import { render, staticRenderFns } from "./SparringBreadcrumbs.vue?vue&type=template&id=5c477127&scoped=true"
import script from "./SparringBreadcrumbs.vue?vue&type=script&lang=js"
export * from "./SparringBreadcrumbs.vue?vue&type=script&lang=js"
import style0 from "./SparringBreadcrumbs.vue?vue&type=style&index=0&id=5c477127&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c477127",
  null
  
)

export default component.exports